import script from "./AvatarGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./AvatarGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__